import React from "react";
import { Layout } from 'antd';
import SlideMenu from '../../layouts/Slider';
import HeaderBar from '../../layouts/Header'
import ContentMain from '../../layouts/Content'
import { http } from '../../utils/http';

const { Header, Content, Sider } = Layout;

class Index extends React.Component {
  state = {
    collapsed: false,
    collapsedWidth: 80,
    indexData: {},
    profileCompletionRequired: true,
  }

  componentDidMount() {
    this.loadProfileRestriction();
  }

  /** 仅同步档案受限状态；弹窗由个人资料页负责展示。 */
  loadProfileRestriction = () => {
    http.post('/api/sprofile/permissions').then((res) => {
      if (res.data.code !== 0) {
        return;
      }

      this.setState({
        profileCompletionRequired: res.data.data?.onboarding?.restricted === true,
      });
    }).catch(() => {
      // 权限状态未知时保持导航禁用，避免受限账号进入其他业务页面。
      this.setState({ profileCompletionRequired: true });
    });
  }

  menuToggle = () => {
    this.setState({
      collapsed: !this.state.collapsed
    })
  }

  menuClose = () => {
    if (this.state.collapsedWidth) return;
    this.setState({
      collapsed: true
    })
  }

  handleOnBrealPoint(broken, e) {
    this.setState({
      collapsed: broken,
      collapsedWidth: broken ? 0 : 80
    });
}

  render() {
    const { profileCompletionRequired } = this.state;

    return (
      <Layout className={profileCompletionRequired ? 'profile-completion-required' : ''} style={{overflowY: 'hidden'}}>
        <Sider
          id="supplier-sider"
          width={215}
          breakpoint="lg"
          collapsedWidth={this.state.collapsedWidth}
          onBreakpoint={(broken) => this.handleOnBrealPoint(broken)}
          collapsible 
          trigger={null} 
          collapsed={this.state.collapsed}>
          <SlideMenu collapsed={this.state.collapsed} close={this.menuClose} />
        </Sider>
        <Layout>
          <Header>
            <HeaderBar collapsed={this.state.collapsed} menuToggle={this.menuToggle} />
          </Header>
          <Content className="x-page-container">
            <ContentMain />
            {/* <Footer style={{textAlign: 'center'}}>科学指南针</Footer> */}
          </Content>
        </Layout>
      </Layout>
    )
  }
};
export default Index;
